/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentType {
  VIRTUAL_CARD = 'VIRTUAL_CARD',
  DIRECT_ACH = 'DIRECT_ACH',
}
